import Swiper from 'swiper/core';
import { Navigation, Autoplay } from 'swiper/modules';

function initExperiencesSlider() {
  const sliders = document.querySelectorAll('.js-experiences-slider');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    new Swiper(slider, {
      modules: [Autoplay, Navigation],
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 24,
      watchOverflow: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          centeredSlides: true,
          spaceBetween: 16,
        },
        576: { slidesPerView: 1.2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2.9 },
      },
    });
  });

  const cards = document.querySelectorAll('.l-experiences__slider-card');
  cards.forEach((card) => {
    const btn = card.querySelector('.js-open-button');

    card.addEventListener('mouseenter', () => {
      card.classList.add('is-open');
    });
    card.addEventListener('mouseleave', () => {
      card.classList.remove('is-open');
    });

    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        card.classList.toggle('is-open');
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initExperiencesSlider());

if (window.acf?.addAction) {
  const rerender = ($el) => initExperiencesSlider($el[0] || $el);
  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
